<div class="pagetitle">
  <div class="row">
    <div class="col-md-6 text-start">
      <h3>
        {{ moduleName }} <span *ngIf="dataLength">- ({{ dataLength }})</span>
      </h3>
      <nav>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:0;" [routerLink]="'/dashboard/dashboard2'">Home</a>
          </li>
          <li class="breadcrumb-item">{{ constructString(moduleName) }}</li>
        </ol>
      </nav>
    </div>
    <div class="col-md-6 text-end">
      <button type="button" *ngIf="showCreate" class="btn btn-primary btn-sm" [routerLink]="routePath">
        {{ btnName }}
      </button>
      &nbsp;&nbsp;
      <button type="button" *ngIf="showList" class="btn btn-primary btn-sm" [routerLink]="routePath">
        {{ moduleName.split(" ")[0] + " List" }}
      </button>
      &nbsp;&nbsp;
      <button *ngIf="showBack" (click)="back()" class="btn btn-primary btn-sm float-right">
        <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
        Back
      </button>
      &nbsp;&nbsp;
      <button *ngIf="showFilterBtn" (click)="updateFilter()" class="btn btn-primary btn-sm float-right me-1">
        <i class="fa fa-arrow-circle-{{showFilter === true ? 'up' : 'down'}}" aria-hidden="true"></i>
        {{showFilter === true ? 'Hide' : 'Show'}} Filter
      </button>
    </div>
    <h1>
      <span class="text-capitalize" *ngIf="userEmail.length">Quintus Id - QT-{{userEmail}}</span>

    </h1>
  </div>
</div>